import { apiSlice } from '../../api/apiSlice';

export const questionSearchApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    searchCastleQuestions: builder.mutation({
      query: (searchRequest) => ({
        url: 'QuestionSearch/SearchCastleQuestions',
        body: searchRequest,
        method: 'POST'
      })
    }),
    searchTeacherQuestions: builder.mutation({
      query: (searchRequest) => ({
        url: 'QuestionSearch/SearchTeacherQuestions',
        body: searchRequest,
        method: 'POST'
      })
    }),
    searchByQuestionId: builder.mutation({
      query: (searchRequest) => ({
        url: 'QuestionSearch/SearchByQuestionId',
        body: searchRequest,
        method: 'POST'
      })
    }),
    searchExamQuestions: builder.mutation({
      query: (searchRequest) => ({
        url: 'QuestionSearch/SearchExamQuestions',
        body: searchRequest,
        method: 'POST'
      })
    }),
    filterCastleQuestions: builder.mutation({
      query: (searchRequest) => ({
        url: 'QuestionSearch/FilterCastleQuestions',
        body: searchRequest,
        method: 'POST'
      })
    }),
    getCastleQuestionsPage: builder.mutation({
      query: ({ pageNumber, pageSize }) => ({
        url: `QuestionSearch/GetCastleQuestionsPage/${pageNumber}/${pageSize}`,
        method: 'POST'
      })
    }),
    goToCastleQuestion: builder.mutation({
      query: ({ questionId, pageSize }) => ({
        url: `QuestionSearch/GoToCastleQuestion/${questionId}/${pageSize}`,
        method: 'POST'
      })
    }),
    getPrimaryCourseList: builder.query({
      query: () => ({
        url: 'QuestionSearch/GetFilters',
        method: 'GET'
      })
    }),
    getStandardsList: builder.mutation({
      query: (standard) => ({
        url: `QuestionSearch/StandardCrumbs/${standard}`,
        method: 'POST'
      })
    }),
    standardsSearch: builder.mutation({
      query: (standard) => ({
        url: `QuestionSearch/StandardSearch/${standard}`,
        method: 'POST'
      })
    }),
    setSelectedCourses: builder.mutation({
      query: (selectedCourses) => ({
        url: 'QuestionSearch/SetSelectedCourses',
        method: 'POST',
        body: selectedCourses
      })
    }),
    getSelectedCourses: builder.query({
      query: () => ({
        url: 'QuestionSearch/GetSelectedCourses',
        method: 'GET'
      })
    }),
    getSearchQuestionProperties: builder.mutation({
      query: (options) => ({
        url: `QuestionSearch/GetQuestionProperties/${options.questionId}/${options.questionSource}`,
        method: 'GET'
      })
    }),
    AddQuestions: builder.mutation({
      query: (options) => ({
        url: `Assignment/${options.id}/AddQuestions`,
        method: 'POST',
        body: options.selectedQuestions
      })
    }),
    SelectRandomQuestions: builder.mutation({
      query: (options) => ({
        url: 'QuestionSearch/SelectRandomQuestions',
        method: 'POST',
        body: options
      })
    }),
    getDBQSets: builder.mutation({
      query: (options) => ({
        url: `QuestionSearch/course/${options.courseId}/DBQSets`,
        method: 'GET'
      })
    }),
    getSetQuestions: builder.mutation({
      query: (options) => ({
        url: `QuestionSearch/course/${options.courseId}/set/${options.setId}/Preview?languageId=${options.languageId}`,
        method: 'GET'
      })
    }),
    getAssignmentQuestions: builder.mutation({
      query: (assignmentId) => ({
        url: `QuestionSearch/GetAssignmentQuestions/${assignmentId}`,
        method: 'GET'
      })
    }),
    GetReadingSetCourses: builder.mutation({
      query: (options) => ({
        url: `Course/ReadingSetCourses/assignment/${options.assignmentId}`,
        method: 'GET'
      })
    }),
    GetLevels: builder.mutation({
      query: (options) => ({
        url: `Level/${options.courseId}`,
        method: 'GET'
      })
    }),
    GetSets: builder.mutation({
      query: (params) => ({
        url: `Set/ReadingSets?${params}`,
        method: 'GET',
        credentials: 'include',
      })
    }),
    AddSetsToAssignment: builder.mutation({
      query: (options) => ({
        url: `Assignment/${options.assignmentId}/ReadingSetQuestions`,
        method: 'POST',
        body: options.setIds
      })
    }),
    GetMathSkillFilters: builder.mutation({
      query: (options) => ({
        url: `QuestionSearch/MathSkillFilters/Course/${options.courseId}`,
        method: 'GET',
      })
    }),
    GetMathSkillQuestions: builder.mutation({
      query: (options) => (
        {
          url: 'Question/SkillQuestions',
          method: 'GET',
          credentials: 'include',
          params: { ...options }
        }
      )
    }),
    getPublicAssignmentQuestions: builder.mutation({
      query: (assignmentId) => ({
        url: `QuestionSearch/PublicAssignmentQuestions/Assignment/${assignmentId}`,
        method: 'GET'
      })
    }),
    getCourseLevels: builder.mutation({
      query: (params) => ({
        url: `Course/CourseLevels?${params}`,
        method: 'GET',
      })
    }),
    getTopicsByLevel: builder.mutation({
      query: (options) => ({
        url: `Topic/${options.courseId}/TopicsByCourseLevel`,
        method: 'POST',
        credentials: 'include',
        body:options.levelIds
      })
    })
  })
});

export const {
  useSearchCastleQuestionsMutation,
  useSearchTeacherQuestionsMutation,
  useSearchByQuestionIdMutation,
  useSearchExamQuestionsMutation,
  useFilterCastleQuestionsMutation,
  useGetCastleQuestionsPageMutation,
  useGoToCastleQuestionMutation,
  useLazyGetPrimaryCourseListQuery,
  useGetStandardsListMutation,
  useStandardsSearchMutation,
  useSetSelectedCoursesMutation,
  useLazyGetSelectedCoursesQuery,
  useGetSearchQuestionPropertiesMutation,
  useAddQuestionsMutation,
  useSelectRandomQuestionsMutation,
  useGetDBQSetsMutation,
  useGetSetQuestionsMutation,
  useGetAssignmentQuestionsMutation,
  useGetReadingSetCoursesMutation,
  useGetLevelsMutation,
  useGetSetsMutation,
  useAddSetsToAssignmentMutation,
  useGetMathSkillFiltersMutation,
  useGetMathSkillQuestionsMutation,
  useAddRandomMathSkillQuestionsMutation,
  useAddMathSkillQuestionsMutation,
  useGetPublicAssignmentQuestionsMutation,
  useGetCourseLevelsMutation,
  useGetTopicsByLevelMutation
} = questionSearchApi;